import { connect } from "react-redux";
import { compose } from "redux";
import { modalActions } from "containers/ModalRoot/modules/modal.slice";
import { injectIntl } from "react-intl";
import {
  deviceEntityActions,
} from "containers/App/modules/entities/devices/deviceEntity.slice";
import {
  devicesActions,
  deviceSelectors,
} from "pages/Devices/modules/devices.slice";
import UploadEventsForm from "../components/UploadEventsForm";

const mapStateToProps = (state, props) => {
  const isUploadPending =
    deviceSelectors.selectIsUploadEventFilesPending(state);

  return {
    isUploadPending,
  };
};

const withConnect = connect(mapStateToProps, {
  ...deviceEntityActions,
  ...devicesActions,
  ...deviceSelectors,
  ...modalActions,
});

export default compose(withConnect, injectIntl)(UploadEventsForm);
